import type { WidgetPeriods } from '../widgets/types'

import { useState } from 'react'

import { formatFilterRule } from '@/entities/column'

import { QuickFiltersBar } from '@/widgets/quick-filters-bar'

import { Header } from '@/shared/components/ui/layout'
import { Skeleton } from '@/shared/components/ui/skeleton'

import {
	useDashboardStore,
	useSelectDashboardFilters,
	useSelectDashboardFiltersKeys,
} from '../../lib/store'
import { useAiDashboardFilterFieldsConfig } from '../../lib/useAiDashboardFilterFieldsConfig'
import { SinglePeriodSelect } from '../Periods'
import SalesFactorsImpactWidget from '../widgets/SalesFactorsImpact/Widget'
import SalesFactorsImpactByCategoriesWidget from '../widgets/SalesFactorsImpactByCategories/Widget'
import SalesFactorsImpactDynamicWidget from '../widgets/SalesFactorsImpactDynamic/Widget'
import { WidgetWrapper } from '../WidgetWrapper'

export default function AiDashboardCommonSection({
	commonPeriods,
}: {
	commonPeriods: WidgetPeriods
}) {
	const [state, setState] = useState(commonPeriods.main)
	const { setFilters, filters } = useDashboardStore(
		useSelectDashboardFilters('ai_common')
	)
	const { storedKeys, setStoredKeys } = useDashboardStore(
		useSelectDashboardFiltersKeys('ai_common')
	)
	const { isLoading, fieldsConfig } = useAiDashboardFilterFieldsConfig()

	return (
		<div>
			<Header className='sticky top-0 z-10 items-center justify-between bg-background/50 px-4 py-2 backdrop-blur-md'>
				<div>
					{isLoading ? (
						<div className='flex items-center space-x-2'>
							<Skeleton className='h-6 w-28' />
							<Skeleton className='h-6 w-20' />
							<Skeleton className='h-6 w-24' />
						</div>
					) : (
						<QuickFiltersBar
							irremovableKeys={['optimization_group_id', 'pos_id']}
							rules={filters}
							storedKeys={storedKeys}
							onSaveStoredKeys={(keys) => setStoredKeys('ai_common', keys)}
							onApply={(rules) => {
								setFilters('ai_common', rules.map(formatFilterRule))
							}}
							fieldsConfig={fieldsConfig}
							limit={7}
						/>
					)}
				</div>

				<SinglePeriodSelect
					period={state}
					defaultPeriod={commonPeriods.main || state}
					onChangePeriod={setState}
					maxDate={new Date()}
				/>
			</Header>
			<div className='grid grid-cols-6 gap-4 p-4'>
				<WidgetWrapper className='col-span-3 row-span-2 min-h-72'>
					<SalesFactorsImpactWidget
						commonPeriods={{ main: state, compared: state }}
						commonFilters={filters}
					/>
				</WidgetWrapper>
				<WidgetWrapper className='col-span-3 row-span-2 min-h-72'>
					<SalesFactorsImpactDynamicWidget
						commonPeriods={{ main: state, compared: state }}
						commonFilters={filters}
					/>
				</WidgetWrapper>
				<WidgetWrapper className='col-span-5 min-h-72'>
					<SalesFactorsImpactByCategoriesWidget
						commonPeriods={{ main: state, compared: state }}
						commonFilters={filters}
					/>
				</WidgetWrapper>
			</div>
		</div>
	)
}
